const data = [
    {
        "name":"Web Development And Javascript Bootcamp ",
        "instructor": "Hasin Haydar",
        "price": 89.99,
        "image":"https://nadia-training.com/wp-content/uploads/2019/03/JavaScript-Essentials-Course.jpg",
        "topic": "Programming",
        "id":"1"
    },{
        "name":"React JS Course: The Beginners Guide (Step by Step)",
        "instructor": "Matthew Fussell",
        "price": 99.50,
        "image":"https://blog.addthiscdn.com/wp-content/uploads/2014/11/addthis-react-flux-javascript-scaling.png",
        "topic": "programming",
        "id":"2"
    },
    {
        "name":"How to Draw From Beginner to Master",
        "instructor": "Matthew",
        "price": 20.66,
        "image":"https://img-a.udemycdn.com/course/240x135/2234122_68c5_8.jpg",
        "topic": "Art",
        "id":"3"
    },
    {
        "name":"The Professional Driving Masterclass",
        "instructor": "Andrew",
        "price": 200,
        "image":"https://img-a.udemycdn.com/course/240x135/677444_cfd4.jpg",
        "topic": "Driving",
        "id":"4"
    },
    {
        "name":"Mastaring Bass",
        "instructor": "Shams",
        "price": 60.99,
        "image":"https://img-a.udemycdn.com/course/240x135/1641684_39a4.jpg",
        "topic": "Music",
        "id":"5"
    },
    {
        "name":"The Professional Networking Masterclass",
        "instructor": "Petruchi",
        "price": 56.99,
        "image":"https://img-a.udemycdn.com/course/240x135/751094_fb27_2.jpg",
        "topic": "IT",
        "id":"6"
    },
    {
        "name":"Professional React Js Masterclass",
        "instructor": "Kirk",
        "price": 30.50,
        "image":"https://img-a.udemycdn.com/course/240x135/1362070_b9a1_2.jpg",
        "topic": "Programming",
        "id":"7"
    },
    {
        "name":"Mastaring c++",
        "instructor": "Hetfield",
        "price": 99.99,
        "image":"https://img-a.udemycdn.com/course/240x135/1576854_9aeb.jpg",
        "topic": "Programming",
        "id":"8"
    },
    {
        "name":"Bass Guitar Masterclass",
        "instructor": "Cliff Burton",
        "price": 120.99,
        "image":"https://img-a.udemycdn.com/course/240x135/456284_80ce_9.jpg",
        "topic": "Music",
        "id":"9"
    },
    {
        "name":"Javascript ES7",
        "instructor": "Slash",
        "price": 79.99,
        "image":"https://img-a.udemycdn.com/course/240x135/1551422_a13e_5.jpg",
        "topic": "Programming",
        "id":"10"
    },
    {
        "name":"Javascript ES6",
        "instructor": "Dave",
        "price": 111.11,
        "image":"https://img-a.udemycdn.com/course/240x135/1105822_de56_4.jpg",
        "topic": "Programming",
        "id":"11"
    },
    {
        "name":"Digital Painting",
        "instructor": "Ps Dude",
        "price": 43.65,
        "image":"https://img-a.udemycdn.com/course/240x135/1239574_6e76.jpg",
        "topic": "Graphic",
        "id":"12"
    },
    {
        "name":"Mastaring c++",
        "instructor": "Hetfield",
        "price": 99.99,
        "image":"https://img-a.udemycdn.com/course/240x135/1576854_9aeb.jpg",
        "topic": "Programming",
        "id":"13"
    },
    {
        "name":"Mastaring PHP",
        "instructor": "Hasin Haydar",
        "price": 89.99,
        "image":"https://img-a.udemycdn.com/course/240x135/1236794_1aba_10.jpg",
        "topic": "Programming",
        "id":"14"
    },{
        "name":"The Colored Pencil Drawing",
        "instructor": "Matthew Fussell",
        "price": 12.50,
        "image":"https://img-a.udemycdn.com/course/240x135/381588_2e6d_4.jpg",
        "topic": "Art",
        "id":"15"
    }
];

export default data;